import { createFileRoute } from "@tanstack/react-router";
import { useTeamState } from "src/components/teams/TeamState";
import LinkSharingPageComponent from "src/features/LinkSharingPageComponent";

export const Route = createFileRoute("/create/_layout/invite")({
  component: RouteComponent,
});

function RouteComponent() {
  const teamName = useTeamState((state) => state.teamName);
  const url = useTeamState((state) => state.shareUrl);
  const message = useTeamState((state) => state.shareText);

  return (
    <LinkSharingPageComponent
      chipText="Free for everyone you invite"
      titleText="Invite people to join"
      teamName={teamName || "Your Team"}
      bodyText="Your team's ready. Send invites to start training together."
      link={url || "https://trainwell.net"}
      shareMessage={message}
    />
  );
}
